"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = readFileToString;
/**
 * Get the content of a File object.
 * @param {File} file
 * @return {string}
 */
function readFileToString(file) {
    return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function (e) {
            resolve(e.target.result);
        };
        reader.onerror = function (e) {
            reject(e.target.error);
        };
        reader.readAsArrayBuffer(file);
    });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ntnu-react/util/readFileToString.js
// module id = 678
// module chunks = 0